<template>
  <div class="p_post_content">
    <div class="topOperation">
        <div class="top-left">
            <ShowNavHead/>
        </div>
    </div>
    <div class="main-con">
        <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>系统</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/postManage' }">岗位管理</el-breadcrumb-item>
                <el-breadcrumb-item>创建岗位</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
      <div class="p_post_form">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="岗位名称" prop="StationName">
              <el-input v-model="ruleForm.StationName" clearable></el-input>
            </el-form-item>
            <el-form-item label="数据权限" prop="perData">
                <el-select v-model="ruleForm.perData" filterable multiple clearable @change="permissionChange">
                  <el-option
                    v-for="(item, index) in permissionList"
                    :key="index+'t'"
                    :label="item.Name"
                    :value="item.Code">
                  </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="岗位描述" prop="StrRemark">
                <el-input v-model="ruleForm.StrRemark" type="textarea" clearable></el-input>
            </el-form-item>
            <el-form-item label="关联角色" prop="roletypeList">
              <el-select v-model="ruleForm.roletypeList" filterable multiple clearable @change="roleChange">
                <el-option
                  v-for="(item, index) in roleList"
                  :key="index+'g'"
                  :label="item.RoleName"
                  :value="item.Roletype">
                </el-option>
              </el-select>
              <!-- <el-checkbox-group v-model="ruleForm.roletypeList" @change="checkboxHandle" class="post_checkbox_box">
                  <el-checkbox v-for="(item,index) in roleList" :label="item.Roletype" :key="index">{{item.RoleName}}</el-checkbox>
              </el-checkbox-group> -->
            </el-form-item>
            <el-form-item label="配置权限" v-if="!isNull(ruleForm.roletypeList)">
              <div class="treeBox" v-loading="loading">
                <el-tree
                  ref="tree"
                  node-key="powercode"
                  show-checkbox
                  :data="allPowerList"
                  :props="defaultProps"
                  highlight-current
                  :default-expanded-keys="['1c895257-a000-d000-b000-adb6df000001','1c895257-a000-d000-b001-adb6df000001']"
                  :expand-on-click-node="false"
                  @check-change="handleNodeClick">
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <!-- 一级菜单图标 -->
                      <span v-if="data.strbanded == 1" class="el-icon-folder-opened"></span>
                      <!-- 二级菜单图标 -->
                      <span v-else-if="data.strbanded == 2&& !isNull(data.children)" class="el-icon-folder-opened"></span>
                      <span v-else-if="data.strbanded == 2&& isNull(data.children)" class="el-icon-folder"></span>
                      <!-- 按钮图标 -->
                      <span v-else-if="data.strbanded == 4" class="el-icon-setting"></span>
                      <span v-else class="el-icon-folder" style="margin-right: 3px"></span>
                      <span>{{ node.label }}</span>
                    </span>
                </el-tree>
              </div>
            </el-form-item>
            <el-form-item label="">
                <el-button @click="backHandle">取消</el-button>
                <el-button :loading="btnloading" type="primary" @click="submitForm('ruleForm')">保存</el-button>
            </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import xz from "@/common"
import moment from 'moment'
export default {
  name: "updatePost",
  data() {
    return {
        // 参数
        ruleForm:{
            Stationid:'', // 岗位id
            StationName:'',// 岗位名称
            Strroletypes:'',// 角色集合
            StrDataperm:'',//数据权限
            perData:[],
            roletypeList:[],
            StrRemark:''
        },
        // 编辑时角色对应选中的配置权限
        checkedList:[],
        defaultProps: {  //组件必须的参数，children和label是组件固定结构，若绑定的数据名字不同，直接赋值即可
            children:'children',    
            label:'powername'
        },
        // 数据权限列表
        permissionList:[],
        // 基础数据参数
        baseQuery: {
          currpage: 1,
          perpage: 100000,
          Parentname: 'stationrole'
        },
        rules: {
          StationName: [
            { required: true, message: '请输入岗位名称', trigger: 'blur' }
          ],
          roletypeList: [
            { type: 'array', required: true, message: '请选择关联角色', trigger: 'change' }
          ],
          perData: [
            { type: 'array', required: true, message: '请选择数据权限', trigger: 'change' }
          ]
        },
        // 角色列表参数
        roleQuery:{
            keyword:'', // 角色名称
            perpage: 10000000,
            currpage: 1
        },
        // 选中角色对应选中的配置权限
        powerList:[],
        // 所有配置权限
        allPowerList:[],
        //取权限菜单参数
        powerQuery:{
          roletype:'', // 根据角色传
          stationid:'',//根据岗位
          roleuserid:'' // 根据员工id(三个都不传为所有菜单 按钮权限)
        },
        loading:false,
        // 角色列表
        roleList:[],
        tableData:[],
        isEdit:'false',
        btnloading:false
    }
  },
  created() {
    let stationid = this.$route.query.Stationid
    if(!this.isNull(stationid)){
      this.ruleForm.Stationid = stationid
      this.ruleForm.StationName = this.$route.query.StationName
      this.ruleForm.Strroletypes = this.$route.query.Strroletypes
      this.ruleForm.StrRemark = this.$route.query.StrRemark
      this.ruleForm.StrDataperm = this.$route.query.StrDataperm
      this.powerQuery.stationid = stationid
      if(!this.isNull(this.$route.query.Strroletypes)){
        this.ruleForm.roletypeList = this.$route.query.Strroletypes.split(',')
      }
      if(!this.isNull(this.$route.query.StrDataperm)){
        let res = this.$route.query.StrDataperm.split(',');
        this.ruleForm.perData = res;
      }
    }
    this.getPermissionList()
    this.getRoleList()
    this.getPowerList()
  },
  methods: {
    // 节点选中状态发生变化时的回调
    handleNodeClick(data, checked, indeterminate){
      // console.log('handleNodeClick',data)
      this.powerList = []
      let checkKeys = this.$refs.tree.getCheckedKeys()
      let checkHAlfKeys = this.$refs.tree.getHalfCheckedKeys()
      // console.log('res',checkKeys,checkHAlfKeys)
      this.powerList = checkKeys.concat(checkHAlfKeys)
    },
    // 保存
    submitForm(formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.ruleForm.StrDataperm = that.ruleForm.perData.toString()
          that.btnloading = true
          // console.log('角色', this.ruleForm,'kk',this.powerList,'uuu',that.checkedList)
          let arrdata = that.powerList.toString()
          xz.bupdateauthStationList(that.ruleForm,arrdata).then(res => {
            // console.log('角色', res)
            if (res.status == 'ok') {
              that.$message({
                type: 'success',
                message: '操作成功！',
                center: true,
                duration: 2000
              });
              that.$router.push({
                path: "/postManage",
              });
            } else {
              that.$message({
                  type: 'error',
                  message: '操作失败，请稍后再试！',
                  center: true,
                  duration: 2000
              });
            }
            that.btnloading = false
          })
        } else {
            console.log('error submit!!');
            return false;
        }
      });
    },
    // 选择角色
    roleChange(val){
      if(!this.isNull(val)){
        this.ruleForm.Strroletypes = val.toString()
        this.powerQuery.stationid = ''
        this.powerQuery.roletype = val.toString()
        this.getPowerList()
      }else{
        this.ruleForm.Strroletypes = ''
      }
    },
    // 选择数据权限
    permissionChange(val){
      // console.log(333,val)
      if(!this.isNull(val)){
        this.ruleForm.StrDataperm = val.toString()
      }else{
        this.ruleForm.StrDataperm = ''
      }
    },
    // 选择复选框
    // checkboxHandle(val){
    //     // console.log(333,val)
    //     if(!this.isNull(val)){
    //         this.ruleForm.Strroletypes = val.toString()
    //         this.powerQuery.stationid = val.toString()
    //     }else{
    //         this.ruleForm.Strroletypes = ''
    //     }
    // },
    // 取消
    backHandle(){
      this.$router.push({
          path: "/postManage",
      });
    },
    isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 'NaN'
    },
    // 获取配置权限菜单列表(通用)
    getPowerList(){
      this.loading = true
      this.checkedList = []
      this.powerList = []
      let that = this
      xz.baLLGetauthPowerInf(this.powerQuery).then(res => {
        // console.log('权限菜单', res)
        if (res.status == 'ok') {
          that.allPowerList = res.msg.parent
          let allList = res.msg.parent
          // 获取默认所有选中的节点--包含父节点
          that.generaNode(that.powerList, allList);
          // 回显默认所有选中的节点--不包含父节点
          that.$nextTick(() => {
            if(!that.isNull(that.powerList)){
              that.powerList.forEach(f => {
                //为了解决父级没有全选中（只选中某个子级）但是数据存在父级id然后回显选中问题
                if (!that.$refs.tree.getNode(f).childNodes || !that.$refs.tree.getNode(f).childNodes.length) {
                  that.checkedList.push(f)
                }
              });
              that.$refs.tree.setCheckedKeys(that.checkedList);
            }
          })
          // console.log('checkedList', that.checkedList)
        } else {
          that.allPowerList = []
        }
        that.loading = false
      })
    },
    // 遍历递归--获取选中的节点
    generaNode(ele, data){
      let that = this
      data.forEach(item => {
        if (!that.isNull(item.children)) {
          that.generaNode(ele, item.children)
        }
        if(item.isused == '1'){
          ele.push(item.powercode)
        }
      })
    },
    // 获取数据权限列表
    getPermissionList(){
      xz.getBasicDatas(this.baseQuery).then(res => {
        // console.log('权限', res)
        if (res.status == 'ok') {
          this.permissionList = res.msg
        } else {
          this.permissionList = []
        }
      })
    },
    // 获取角色列表
    getRoleList(){
      xz.bgetRoleauthList(this.roleQuery).then(res => {
        // console.log('角色', res)
        if (res.status == 'ok') {
          let result = res.msg
          this.roleList = result.filter((num) => {
            return num.Roletype != 'adminuser';
          });
        } else {
          this.roleList = []
        }
      })
    }
  }
}
</script>
<style scoped>
.treeBox{
    width: 600px;
    max-height: 450px;
    min-height: 30px;
    overflow-y: auto;
    border:1px solid #DCDFE6;
    padding-left: 15px;
    box-sizing: border-box;
}
.p_btn_box{
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
  padding-right: 10px;
  box-sizing: border-box;
  margin-bottom: 10px;
}
.p_post_form{
    background-color: #fff;
    padding: 15px 10px;
}
.post_checkbox_box{
    width: 600px;
    max-height: 450px;
    min-height: 30px;
    overflow-y: auto;
    border:1px solid #DCDFE6;
    padding-left: 15px;
    box-sizing: border-box;
}
</style>
<style>
.p_post_content .p_post_form .el-form-item__label{
    color:#000;
}
.p_post_content .p_post_form .el-input,.p_post_content .p_post_form .el-textarea{
    width: 600px;
}
.p_post_content .p_post_form label.el-checkbox{
    display: block;
}
</style>